import React, { ReactNode } from 'react'
import { StyleProp, StyleSheet, View, ViewProps, ViewStyle } from 'react-native'
import { Resizable } from 'react-native-web-hooks'

import { Color, Radius } from '../../style'

import { isMobile, isTablet } from './helper'

const styles = StyleSheet.create({
  container: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: Color.sleepingGrey,
    alignItems: 'center',
    justifyContent: 'center',
  },
  content: {
    flex: 1,
  },
  box: {
    borderRadius: Radius.L,
    overflow: 'hidden',
  },
})

export interface Props extends ViewProps {
  threshold?: number
  header?: ReactNode
  footer?: ReactNode
  background?: ReactNode
  backgroundStyle?: StyleProp<ViewStyle>
}
const LayoutPanel = (props: Props) => {
  const { children, threshold, style, header, footer, background, backgroundStyle, ...otherProps } = props
  if (isMobile() && !isTablet()) {
    if (header || footer) {
      return (
        <View style={styles.content}>
          {header}
          <View style={styles.content}>{children}</View>
          {footer}
        </View>
      )
    } else {
      return <>{children}</>
    }
  }

  const renderPanel = (layout: { width: number }) => {
    const minWidth = threshold || 600
    const showPanel = !layout.width || layout.width > minWidth
    const contentStyle = {
      minWidth,
    }
    return showPanel ? (
      <View style={[styles.container, backgroundStyle]}>
        {background}
        <View style={contentStyle}>
          {header}
          <View style={[styles.box, style]} {...otherProps}>
            {children}
          </View>
          {footer}
        </View>
      </View>
    ) : (
      children
    )
  }

  return <Resizable>{renderPanel}</Resizable>
}

export default LayoutPanel
